export enum AuthScope {
    SUPER_ADMIN = 'super_admin',
    BUSINESS_PARTNER = 'business_partner',
    COMPANY_CUSTOMER = 'compnay_customer',
    CUSTOMER = 'customer',
}
